import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { IPlannedRouteNote } from "@tms/_models/IPlannedRouteNote";
import "./notes.component.scss";


@Component({
    selector: 'history-notes',
    template: require("./notes.component.html")
})
export class HistoryNotesComponent implements OnInit, OnChanges {
    @Input() notes: IPlannedRouteNote[];
    @Output() newNoteAdded = new EventEmitter<IPlannedRouteNote>();

    notesForm: FormGroup;

    constructor() { }

    ngOnInit(): void {
        this.initForm();
    }

    ngOnChanges(): void {
    }

    initForm(): void {
        this.notesForm = new FormGroup({
            'noteTextToAdd': new FormControl('', Validators.required)
        })
    }

    addNote() {
        const newNote: IPlannedRouteNote = {
            Note: this.notesForm.get('noteTextToAdd').value
        }
        if (this.newNoteAdded) {
            this.newNoteAdded.emit(newNote);
        }

        this.notesForm.reset();
    }
}
